module.exports = __webpack_public_path__ + "img/mira-newPicture.e5649e4a.svg";